/**
 * Minha Conta Lev — navbar session label.
 * Replaces "Login" with "Olá, {email}" when the OTP session cookie is present.
 */
(function () {
  'use strict';

  var LOCAL_API = 'http://127.0.0.1:3001';
  var NETLIFY_API = 'https://lev-minhaconta.netlify.app';
  var SESSION_TOKEN_KEY = 'lev_mc_session_token';
  var LOGIN_LABEL = 'Login';

  function getSessionToken() {
    try {
      return localStorage.getItem(SESSION_TOKEN_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function resolveApiBase() {
    try {
      var params = new URLSearchParams(window.location.search);
      var apiParam = params.get('api');
      if (apiParam === 'local') {
        localStorage.setItem('lev_mc_api_base', LOCAL_API);
        return LOCAL_API;
      }
      if (apiParam === 'netlify') {
        localStorage.setItem('lev_mc_api_base', NETLIFY_API);
        return NETLIFY_API;
      }
      var host = window.location.hostname;
      if (host === '127.0.0.1' || host === 'localhost') {
        localStorage.setItem('lev_mc_api_base', LOCAL_API);
        return LOCAL_API;
      }
      var stored = localStorage.getItem('lev_mc_api_base');
      if (stored) {
        stored = String(stored).replace(/\/$/, '');
        if (
          stored.indexOf('127.0.0.1') === -1 &&
          stored.indexOf('localhost') === -1
        ) {
          return stored;
        }
      }
    } catch (e) {}
    return NETLIFY_API;
  }

  function links() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-lev-user-link]')
    );
  }

  function setUser(email) {
    var label = email ? 'Olá, ' + email : LOGIN_LABEL;
    var title = email || LOGIN_LABEL;
    links().forEach(function (el) {
      el.textContent = label;
      el.setAttribute('title', title);
      el.setAttribute('aria-label', email ? 'Minha Conta' : LOGIN_LABEL);
      if (email) el.classList.add('is-logged-in');
      else el.classList.remove('is-logged-in');
    });
  }

  async function refresh() {
    var apiBase = resolveApiBase();
    if (!apiBase) {
      setUser(null);
      return;
    }
    try {
      var headers = { Accept: 'application/json' };
      var token = getSessionToken();
      if (token) headers.Authorization = 'Bearer ' + token;
      var res = await fetch(apiBase + '/api/minhacontalev/auth/session', {
        credentials: 'include',
        headers: headers,
      });
      if (!res.ok) {
        setUser(null);
        return;
      }
      var data = await res.json();
      if (!data.authenticated || !data.email) {
        setUser(null);
        return;
      }
      setUser(String(data.email));
    } catch (err) {
      setUser(null);
    }
  }

  window.LevMinhaContaNav = {
    setUser: setUser,
    refresh: refresh,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });
})();
